module.exports = __webpack_public_path__ + "img/J12326.99ca57c8.png";